import React from 'react';
import { Link } from 'react-router-dom';
import { UserRound, LogOut, ArrowLeft } from 'lucide-react';
import { Menu, MenuItem, MenuLabel, MenuDivider } from '../ds';
import { cx, focusRing, motion } from '../ds/classes';
import { useAuth } from '../../context/AuthContext';

/**
 * The signed-in account's menu: who's signed in and Log out. In the studio (`inStudio`) it also
 * leads back to the site, since the studio bar has no site links of its own.
 */
export const AccountMenu = ({ inStudio = false }) => {
  const { user, logout } = useAuth();

  return (
    <Menu
      trigger={(props) => (
        <button
          type="button"
          aria-label="Account"
          className={cx(
            'w-target-min h-target-min flex-none rounded-full inline-flex items-center justify-center bg-raised text-ink-soft transition-colors hover:text-ink',
            motion,
            focusRing
          )}
          {...props}
        >
          <UserRound size={20} strokeWidth={2.5} aria-hidden="true" />
        </button>
      )}
    >
      {user?.email && <MenuLabel title={user.email}>Signed in</MenuLabel>}
      {user?.email && <MenuDivider />}
      {inStudio && <MenuItem as={Link} to="/" icon={ArrowLeft}>Back to the site</MenuItem>}
      <MenuItem icon={LogOut} onSelect={logout}>Log out</MenuItem>
    </Menu>
  );
};
